import type {ComponentType} from "react";
import {memo} from "react";

import {ArrowTopRightIcon} from "../../react/components/Icons";
import {HStack} from "../ui/hstack";
import type {IIConProps} from "../ui/icon";

import DropdownContent from "./DropdownContent";
import type {PressDowndownType} from "./types";

export type Props = {
    type?: PressDowndownType["type"];
    label: string;
    Icon: React.ReactElement<any> | ComponentType<IIConProps>;
    size?: "xs" | "sm";
};

const DropdownItemLink: React.FC<Props> = ({type, label, Icon, size}) => {
    const MenuContent = (
        <DropdownContent Icon={Icon} size={size}>
            {label}
        </DropdownContent>
    );

    if (type === "external") {
        return (
            <HStack className="w-full justify-between items-center">
                {MenuContent}
                <ArrowTopRightIcon size="xs" stroke="blueGray.400" />
            </HStack>
        );
    }

    return MenuContent;
};

export default memo(DropdownItemLink);
